import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  AbstractProductDisplayService,
  ProductDisplayReadOnlyComponent,
  ProductDisplayReadOnlyService,
} from '@mkp/product/feature-product-display';

@Component({
  selector: 'mkp-products',
  templateUrl: 'products.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ProductDisplayReadOnlyComponent],
  providers: [
    {
      provide: AbstractProductDisplayService,
      useClass: ProductDisplayReadOnlyService,
    },
  ],
})
export class ProductsComponent {
  @Input() showPlatformSwitch = false;
  @Input() showStickyHeader = false;
}
